import { render } from "./KreaNumberInput.vue?vue&type=template&id=0b2c0e53"
import script from "./KreaNumberInput.vue?vue&type=script&lang=js"
export * from "./KreaNumberInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__